<template>
	<NuxtLayout
		name="standard"
		:menu-items="mainMenuItems()"
		page-title="Cookie instellingen"
	>
		<div class="bg-gray-50">
			<div class="container flex flex-col pt-28 pb-56 px-8">
				<OrganismFormCookieConsent class="bg-purple-900 px-12 rounded text-white" />
			</div>
		</div>
	</NuxtLayout>
</template>

<script lang="ts" setup>
defineRouteRules({
	robots: false,
});
</script>
